// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取小程序配置 读取服务端 JSON 配置并返回给小程序端 GET /api/v1/miniapp/config */
export async function AppControllerGetMiniappConfigV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputMiniappConfigDto>(
    "/api/v1/miniapp/config",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
